"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var core_1 = require("@material-ui/core");
var clsx_1 = require("clsx");
var Button_1 = require("@material-ui/core/Button");
var Translation_1 = require("../../../../../../common/components/presentation/Translation/Translation");
var itemButtonStyles_1 = require("./itemButtonStyles");
var ItemButton = function (_a) {
    var _b;
    var isSelected = _a.isSelected, onClick = _a.onClick;
    var styles = itemButtonStyles_1.default();
    return (<core_1.Box className={styles.buttonWrapper}>
      <Button_1.default type="button" className={clsx_1.default([
        styles.button,
        (_b = {},
            _b[styles.isSelected] = isSelected,
            _b),
    ])} data-test={'checkout:extras:expression_of_interest:button'} variant="outlined" onClick={onClick} classes={{ outlinedPrimary: styles.outlinedPrimary }}>
        <Translation_1.default id={isSelected ? 'trans__checkout__extras_page__eoi_remove_cta' : 'trans__checkout__extras_page__eoi_add_cta'} className={styles.buttonLabel}/>
      </Button_1.default>
    </core_1.Box>);
};
exports.default = ItemButton;
